import { Typography } from '@mui/material';
import React from 'react';

import { StepComponentProps } from 'components/Flow/RenderMachine';
import config from 'config';

import { Layout } from './Components/Layout';

export const Membership = ({ send }: StepComponentProps) => (
  <Layout title="Other Nonprofit Membership Organization" send={send}>
    <Typography variant="h4" fontWeight={500} lineHeight="38px" mb={3}>
      Organizations with an EIN but Without Tax-Exempt Status.
    </Typography>
    <Typography fontSize={15} lineHeight="38px" mb={3}>
      Make sure you have one of the following subcodes: 501(c)(4), 501(c)(6), or 501(c)(19) and are
      listed with the IRS. If not,{' '}
      <a
        href={`mailto:${config.nonprofitSuccessTeamEmail}`}
        style={{ textDecoration: 'underline' }}
      >
        contact the nonprofit support team
      </a>{' '}
      for assistance.
    </Typography>
  </Layout>
);
